
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_9pxbo_17",
  "full-width": "awsui_full-width_8cbea_9pxbo_44",
  "refresh": "awsui_refresh_8cbea_9pxbo_47",
  "disabled": "awsui_disabled_8cbea_9pxbo_53",
  "selected": "awsui_selected_8cbea_9pxbo_116",
  "icon": "awsui_icon_8cbea_9pxbo_127",
  "with-text": "awsui_with-text_8cbea_9pxbo_131",
  "with-no-text": "awsui_with-no-text_8cbea_9pxbo_140",
  "root": "awsui_root_8cbea_9pxbo_145",
  "segment-part": "awsui_segment-part_8cbea_9pxbo_177",
  "grouped": "awsui_grouped_8cbea_9pxbo_201",
  "grouped-only": "awsui_grouped-only_8cbea_9pxbo_201",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_9pxbo_205",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_9pxbo_216",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_9pxbo_220",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_9pxbo_226",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_9pxbo_230",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_9pxbo_234",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_9pxbo_240",
  "grouped-with-action": "awsui_grouped-with-action_8cbea_9pxbo_244",
  "select": "awsui_select_8cbea_9pxbo_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_9pxbo_261",
  "segment-count-3": "awsui_segment-count-3_8cbea_9pxbo_268",
  "segment-count-4": "awsui_segment-count-4_8cbea_9pxbo_275",
  "segment-count-5": "awsui_segment-count-5_8cbea_9pxbo_282",
  "segment-count-6": "awsui_segment-count-6_8cbea_9pxbo_289",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_9pxbo_296"
};
  